@if (isOpen) {
  <div class="popup-overlay-backdrop" (click)="onBackdropClick()">
    <div
      #contentEl
      class="popup-overlay-content"
      [class.position-bottom]="position === 'bottom'"
      [class.is-dragging]="isDragging"
      [style.maxWidth]="maxWidth"
      [style.maxHeight]="maxHeight"
      [style.transform]="getContentTransform()"
      [style.opacity]="getContentOpacity()"
      (click)="onContentClick($event)"
      (touchstart)="onTouchStart($event)"
      (touchmove)="onTouchMove($event)"
      (touchend)="onTouchEnd()">
      <div class="popup-header">
        <span class="popup-title">{{ title | translate }}</span>
        @if (showCloseButton) {
          <button class="popup-close" (click)="onCloseClick()">
            <span class="material-icons">close</span>
          </button>
        }
      </div>
      <div class="popup-body">
        <ng-content />
      </div>
    </div>
  </div>
}
